import { render, staticRenderFns } from "./ProfilePictureManage.vue?vue&type=template&id=9a256804&"
import script from "./ProfilePictureManage.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureManage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePictureManage.vue?vue&type=style&index=0&id=9a256804&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports